export const FETCH_CONVERSATIONS = 'FETCH_CONVERSATIONS'
export const SET_CONVERSATIONS = 'SET_CONVERSATIONS'
export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT'
